// "העתקה ממשימה אחרת" — a new list made from another task's: its states and columns, and,
// if chosen, its rows (back in the starting state). The journalist list built for one
// client becomes the next client's starting point.
import he from '../../i18n/he';
import useAsync from '../../hooks/useAsync';
import { taskListsApi } from '../../api';
import { Select } from '../Form';
import { definitionCopiedFrom, copiedRows } from './shapes';

const L = he.lists;

export default function CopyFromTask({ taskId, draft, onDraft }) {
  const { data } = useAsync(() => taskListsApi.index(), []);
  const options = [
    { value: '', label: '—' },
    ...(data || []).filter((r) => r.task_id !== taskId).map((r) => ({
      value: r.task_id,
      label: `${r.title} · ${r.client_id == null ? he.tasks.internal : r.client_name} (${L.rows(r.summary.total)})`,
    })),
  ];

  const pick = async (e) => {
    const id = Number(e.target.value);
    if (!id) return;
    const source = await taskListsApi.get(id);
    onDraft({ ...definitionCopiedFrom(source.list), sourceTaskId: id, sourceItems: source.list.items, copyRows: false });
  };

  return (
    <div className="list-copy">
      <Select label={L.copyPick} value={draft?.sourceTaskId || ''} onChange={pick} options={options} />
      {draft?.sourceItems?.length > 0 && (
        <label className="setup-check">
          <input type="checkbox" checked={!!draft.copyRows} onChange={(e) => onDraft({ ...draft, copyRows: e.target.checked })} />
          {L.copyRows(draft.sourceItems.length)}
        </label>
      )}
    </div>
  );
}

// After the new list is saved: its copied rows, if the owner asked for them.
export async function addCopiedRows(taskId, draft) {
  if (!draft?.copyRows || !draft.sourceItems?.length) return;
  const created = await taskListsApi.get(taskId);
  await taskListsApi.addItems(taskId, copiedRows(draft.sourceItems, draft.columns, created.list));
}
